import { ContactLink } from 'features/auth/types';
import { parsePhoneNumber, safeFormatToNational } from './phoneNumberUtils/phoneNumberUtils';

/**
 * Generates the initials from a given full name.
 *
 * @param name - The full name from which to generate initials.
 * @returns The initials of the given name in uppercase.
 */
export const getNameInitials = (name: string) => {
  const nameParts = name.split(' ');
  const initials = nameParts.map((part) => part.charAt(0).toUpperCase()).join('');
  return initials;
};

export interface ContactInfo {
  displayValue: string;
  url: string;
}

const defaultContactLinkData = {
  displayValue: parsePhoneNumber('+18444524085')?.formatNational() ?? '+18444524085',
  url: 'tel:+18444524085',
};

export const getContactLinkData = (contactLink?: ContactLink): ContactInfo | null => {
  if (!contactLink || !contactLink.value || !contactLink.type) {
    return null;
  }

  switch (contactLink.type) {
    case 'email':
      return {
        displayValue: contactLink.displayValue ?? contactLink.value,
        url: `mailto:${contactLink.value}`,
      };
    case 'phone':
      return {
        displayValue: contactLink.displayValue ?? safeFormatToNational(contactLink.value),
        url: `tel:${contactLink.value}`,
      };
    default:
      return defaultContactLinkData;
  }
};

export const getContactLinkDataWithDefault = (contactLink?: ContactLink): ContactInfo => {
  const data = getContactLinkData(contactLink);
  return data ?? defaultContactLinkData;
};

export const isDeviceOnline = () => navigator.onLine;
